import { instance } from '@/libs/api/instance'

/**
 * Get currencies available for creating a card wallet.
 *
 * @return {Promise<AxiosResponse<any>>}
 */
export const getCurrencyList = () => instance.get('/v1/wallet/list/currency')
